import { render, staticRenderFns } from "./SingPauseSchulenContacts.vue?vue&type=template&id=a5569db2&"
import script from "./SingPauseSchulenContacts.vue?vue&type=script&lang=js&"
export * from "./SingPauseSchulenContacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports